let o = Promise.resolve();
async function r({
  key: e = process.env.VITE_ZENDESK_KEY,
  departmentId: d = process.env.VITE_ZENDESK_DEPARTMENT_ID,
  user: i = void 0
} = {}) {
  if (!e)
    throw new Error("Zendesk misconfigured");
  return (i == null ? void 0 : i.role) === "student" && (window.zESettings = {
    webWidget: {
      contactForm: {
        suppress: !0
      }
    }
  }), o = new Promise((s, n) => {
    const t = document.createElement("script");
    t.src = `https://static.zdassets.com/ekr/snippet.js?key=${e}`, t.id = "ze-snippet", t.async = !0, t.defer = !0, t.onload = () => s(), t.onerror = n, document.head.appendChild(t);
  }), i && o.then(async () => {
    await w(i);
  }), d && o.then(async () => {
    var s;
    (s = window.zE) == null || s.call(window, "webWidget:on", "chat:departmentStatus", (n) => {
      var t;
      `${n.id}` == `${d}` && ((t = window.zE) == null || t.call(window, "webWidget", "updateSettings", {
        webWidget: {
          chat: {
            departments: {
              enabled: [""],
              select: n.name
            },
            suppress: n.status !== "online"
          }
        }
      }));
    });
  }), o;
}
function c(e) {
  const d = e.role === "student" ? `${e.firstName}-${e.id}` : e.name, i = e.role === "student" ? "" : e.email || e.username || e.id;
  return {
    name: d,
    email: i
  };
}
async function w(e) {
  var d, i, s, n;
  if (e) {
    const { name: t, email: a } = c(e);
    (d = window.zE) == null || d.call(window, "webWidget", "identify", { name: t, email: a }), (i = window.zE) == null || i.call(window, "webWidget", "prefill", {
      name: { value: t },
      email: { value: a }
    }), (s = window.zE) == null || s.call(window, "webWidget", "chat:addTags", [
      `paper_id:${e.id || "N/A"}`,
      `district_id:${e.district_id || "N/A"}`
    ]);
  } else
    (n = window.zE) == null || n.call(window, "webWidget", "logout");
}
export {
  w as identifyZendeskUser,
  r as initializeZendesk,
  o as zendeskInitializedPromise
};
